import tw, { styled } from 'twin.macro';

const MarkdownTableHead = styled.thead`
  ${tw`py-2 text-xs uppercase tracking-wide font-semibold border-0 border-b border-solid `}
`;

export default MarkdownTableHead;
